import React, { useEffect } from 'react'
import { themeSettingMeta, hasRequiredThemeSettings } from '../../../helpers/utils'

const TrustpilotProductReviewsMultiSourceSEOWidget = ({ sku, reference }) => {
  const requiredMeta = ['trustpilot_template_id', 'trustpilot_businessunit_id']

  if (!hasRequiredThemeSettings(requiredMeta)) {
    console.error(
      '<TrustpilotProductReviewsMultiSourceSEOWidget> missing some meta amongst',
      requiredMeta
    )
    return null
  }

  /* global Shopify */
  const fullLocale = `${Shopify.locale}-${Shopify.locale.toUpperCase()}`

  const templateId = themeSettingMeta('trustpilot_template_id')
  const businessUnitId = themeSettingMeta('trustpilot_businessunit_id')

  const widgetHeight = `${themeSettingMeta('trustpilot_widget_height')}px`
  const widgetWidth = '100%'
  const widgetTheme = themeSettingMeta('trustpilot_widget_theme')
  const widgetStarColor = themeSettingMeta('trustpilot_widget_star_color')
  const widgetFontFamily = themeSettingMeta('trustpilot_widget_font_family')
  const widgetTextColor = themeSettingMeta('trustpilot_widget_text_color')
  const widgetLinkColor = themeSettingMeta('trustpilot_widget_link_color')

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(reference.current, true)
    }
  }, [sku])

  return (
    <div
      ref={reference}
      className='trustpilot-widget'
      data-locale={fullLocale}
      data-template-id={templateId}
      data-businessunit-id={businessUnitId}
      data-style-height={widgetHeight}
      data-style-width={widgetWidth}
      data-theme={widgetTheme}
      data-sku={sku}
      data-review-languages={Shopify.locale}
      data-star-color={widgetStarColor}
      data-font-family={widgetFontFamily}
      data-text-color={widgetTextColor}
      data-link-color={widgetLinkColor}
    >
      <a href='https://fr.trustpilot.com/review/www.joone.fr' target='_blank' rel='noopener noreferrer'>Trustpilot</a>
    </div>
  )
}

export default TrustpilotProductReviewsMultiSourceSEOWidget
